module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"date":"Criada em {0}","sends":"Quantidade total de SMS Enviados","last":"Últimas mensagens enviadas","received":"Mensagens retornadas","inbound":"Quantidade total de SMS retornado(s)","error":"Mensagens com problemas","token":"RD station token:","without":{"sent":"Esta mensagem não possui envios.","error":"Todas as mensagens foram enviadas.","received":"Esta mensagem não tem retorno"},"edit":"Editar"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Campaign/Show.vue
// module id = 150
// module chunks = 0